import { MenuItem, useDisclosure } from "@chakra-ui/react";

import { CallDetailResultFromAPI } from "../../../types";
import ModifyCallModal from "./ModifyCallModal";

interface ModifyCallMenuItemProps {
  record: CallDetailResultFromAPI;
  onSuccess?: () => void;
}

const ModifyCallMenuItem = ({ record, onSuccess }: ModifyCallMenuItemProps) => {
  const {
    isOpen: isOpenModifyCallModal,
    onOpen: onOpenModifyCallModal,
    onClose: onCloseModifyCallModal,
  } = useDisclosure();

  return (
    <>
      <MenuItem data-testid="action-modify" onClick={onOpenModifyCallModal}>
        Modify
      </MenuItem>
      <ModifyCallModal
        isOpen={isOpenModifyCallModal}
        onClose={onCloseModifyCallModal}
        record={record}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default ModifyCallMenuItem;
